export const jwksMock = {
  keys: [
    {
      use: 'sig',
      kty: 'RSA',
      n: 'sLSyNfbuuJCNhrIp_87pkTym5MRw2AxupTHSvBkUYUvTZwuJzVZ-YKvRcp2Ao9jrp4EjS0hPGBW9ELKiHRD21VxqChyMYficzeXtcrylmu-iI_iCmqH0Z7lvXgpC1VTulj-Squr0dqv8r22e7r9WgtxSrr8mM6eOE6T3Fgu6fM1NDwrn2R9ohQjTH7Z02y36p51zW_AYY6yEVHhYhn4GxAZsHrUVby-bpibrRooasGowXYfcbkN_dOmmPi5TY_V1Cqep1YtPG5Ja_SxGLmeOSywBpJX2hzdk3uoEsOfeBUTXIW3BAot5uQoTehiQqbwVX-AO2vONS6S-nYRXA6Ml4w',
      e: 'AQAB',
      kid: '6444c092-40ef-49c5-8b54-b9895efec7e9',
    },
  ],
};
